/* Keep collection cards on the native, responsive card layout.  Older
   presentation scripts may leave inline grid placement styles behind after
   Shopify redraws filter results; those styles are not valid for the current
   card markup and can collapse titles, prices, and actions. */
(() => {
  if (window.__amcCollectionLayoutGuard) return;
  window.__amcCollectionLayoutGuard = true;

  const clear = (node, properties) => {
    if (!node) return;
    properties.forEach((property) => node.style.removeProperty(property));
  };

  const normalize = (root = document) => {
    if (!root.querySelectorAll) return;
    root.querySelectorAll('#MainContent .amc-uniform-card').forEach((card) => {
      const content = card.querySelector('.card__content:not(.card__content--badge)');
      const info = card.querySelector('.card__information');
      const heading = card.querySelector('.card__heading');
      const price = card.querySelector('.price');
      const priceContainer = card.querySelector('.price__container');
      const meta = card.querySelector('.amc-card-meta, .amc-card-model');
      const brand = card.querySelector('.amc-card-brandline, .product-vendor');
      const actions = card.querySelector('.quick-add');
      const actionOpener = actions && actions.querySelector('modal-opener');

      clear(content, ['display', 'grid-template', 'grid-template-columns', 'grid-template-rows', 'grid-template-areas', 'gap', 'height', 'min-height', 'max-height', 'overflow']);
      clear(info, ['display', 'grid-template', 'grid-template-columns', 'grid-template-rows', 'grid-template-areas', 'gap', 'height', 'min-height', 'max-height', 'overflow']);
      clear(heading, ['grid-area', 'grid-column', 'grid-row', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height']);
      clear(price, ['grid-area', 'grid-column', 'grid-row', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height', 'overflow']);
      clear(priceContainer, ['display', 'grid-template', 'grid-template-columns', 'grid-template-rows', 'grid-template-areas', 'gap', 'height', 'min-height', 'max-height', 'overflow']);
      clear(meta, ['grid-area', 'grid-column', 'grid-row', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height']);
      clear(brand, ['grid-area', 'grid-column', 'grid-row', 'width', 'min-width', 'max-width', 'height', 'min-height', 'max-height']);
      clear(actions, ['grid-area', 'grid-column', 'grid-row', 'width', 'height', 'min-height', 'max-height', 'margin-bottom', 'font-size', 'line-height']);
      clear(actionOpener, ['position', 'inset', 'top', 'right', 'bottom', 'left', 'transform']);
    });
  };

  const hasCards = (root = document) => Boolean(
    root.querySelector && root.querySelector('#MainContent .amc-uniform-card')
  );

  const schedule = (event) => {
    const root = event && event.target && event.target.querySelector ? event.target : document;
    if (!hasCards(root) && !hasCards(document)) return;
    [0, 450, 1500, 3000].forEach((delay) => setTimeout(() => normalize(root), delay));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  document.addEventListener('shopify:section:load', schedule);
  window.addEventListener('resize', () => {
    if (hasCards(document)) setTimeout(normalize, 100);
  }, { passive: true });
})();
